"use strict";

import React from "react";
import ReactDOM from "react-dom";
import PropTypes from 'prop-types';
import Utils from '../Utils.jsx';
import PigNormal from '../../../Content/img/criticalillness/CriticalIllnessPigNormal.gif';
import PigWorried from '../../../Content/img/criticalillness/CriticalIllnessPigWorried.gif';
import PigPanicked from '../../../Content/img/criticalillness/CriticalIllnessPigPanicked.gif';

class CriticalIllnessExpenseCalcSummary extends React.Component {
	constructor(props) {
		super(props);

	}

	render() {

		var worriedThreshold = this.props.Worried_Threshold;
		var savingsLeft = this.props.Savings_Left;
		var surplusDeficit = this.props.Surplus_Deficit;
		var recoveryTime = this.props.Recovery_Time;
		var totalExpenses = this.props.Total_Expenses;
		var accumulatedSavings = this.props.Accumulated_Savings;

		var whichpig;
		var { dollarResult, ouchOrPhewClass, ctaActionStmt } = "";

		var imgStyle = {
			width: '95%'
		};


		//savingsLeft = savingsLeft < 0 ? 0 : savingsLeft;
		
		
		ctaActionStmt = <div><span>Get up to $1,000,000 in Critical Illness Insurance so you can </span>
							<strong>PROTECT&nbsp;YOUR&nbsp;SAVINGS</strong><span> and </span>
							<strong>FOCUS&nbsp;ON&nbsp;YOUR&nbsp;RECOVERY</strong>
						</div>;
		
		whichpig = <img src={PigWorried} className="ci-pig ci-pigworried" />;
		ouchOrPhewClass = "ci-short";

		if (surplusDeficit < worriedThreshold) {
			whichpig = <img src={PigPanicked} className="ci-pig ci-pigpanicked" />;
			ouchOrPhewClass = "ci-short ci-panic";
		}


		return <div className={'row ci-summaryonpage ' + ouchOrPhewClass} >
			<h2>YOUR RESULTS</h2>
			<div className="col-xs-6">
				<div className="ci-calc">
					<div className="ci-pigblocksm">
						{whichpig}
					</div>

				</div>
			</div>
			<div className="col-xs-6">
				<div className="ci-ctablock">

					<div className="ci-results">
						<div className="ci-recoverytime"><span>Your Recovery Time</span> <span>{Utils.formatDisplayValue(this.props.Recovery_Time, "daterange", false)}</span></div>
						<div className="ci-savingsleft">
							<table className="ci-tblimpactcalc">
								<tr>
									<td>{Utils.formatDisplayValue(this.props.Accumulated_Savings, "currency")}</td>
									<td>Accumulated Savings</td>
								</tr>
								<tr className="ci-total-expenses">
									<td><span>&ndash;</span> <span>{Utils.formatDisplayValue(this.props.Total_Expenses, "currency")}</span></td>
									<td>Recovery Expenses</td>
								</tr>
								<tr className="ci-savings-left">
									<td>{Utils.formatDisplayValue(savingsLeft, "currency")}</td>
									<td>Savings Left</td>
								</tr>
							</table>
						</div>
					</div>
					<div className="ci-cta-actionstmt">{ctaActionStmt}</div>
					<div className="ci-cta">
						<div className="ci-cta-actionbtntray">
							<a href="https://www.bluecross.ca/life/?utm_source=pacific_blue_cross" className="ui button primary btn btn-primary ci-cta-actionbtn" id="ip-cii-expensecalculatorpage-triggar-get-a-quote-btm-banner" >Get a Quote</a>
						</div>
					</div>
				</div>
			</div>
		</div>


	}
}

CriticalIllnessExpenseCalcSummary.propTypes = {
	Worried_Threshold: PropTypes.number,
	Surplus_Deficit: PropTypes.number,
	Savings_Left: PropTypes.number,
	Recovery_Time: PropTypes.number,
	Accumulated_Savings: PropTypes.number,
	Total_Expenses: PropTypes.number
}

export default CriticalIllnessExpenseCalcSummary;